import React from 'react';

const ToggleSwitch = ({
  toggleData,
  value,
  onChange,
  ...props
}) => {
  return (
    <>
      <div className="flex overflow-hidden border border-[#69a4ce] rounded-md">
        {toggleData.map((data, index) => (
          <label htmlFor={data.id} className="cursor-pointer" key={index}>
            <input
              type="radio"
              name={data.name}
              id={data.id}
              className="sr-only peer"
              checked={value === data.name ? true : false}
              onChange={onChange}
              data-testid={data['data-testid'] ?? data.testId}
              {...props}
            />
            <span
              className={`relative inline-flex items-center h-full py-1.5 px-3 text-sm peer-checked:bg-[#69a4ce] peer-checked:text-white`}
            >
              {data.label}
            </span>
          </label>
        ))}
      </div>
    </>
  )
}

export default ToggleSwitch;